export default {
  noActiveJob: 'No active jobs found',
  pinnedSensorModalHeader: 'Select pinned sensors',
  pinnedSensorListHeadline: 'Pinned sensors',
  jobTableHeader: 'Running job in selected time range',
};
